import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type RoboticMowerCommand from '~/ducks/robotic-mower-command/robotic-mower-command';
import type RoboticMowerSetting from '~/ducks/robotic-mower-command/robotic-mower-setting';

export interface ErrorCommand {
  errorId: number;
  assetId: AssetId;
  commandName: RoboticMowerCommand | RoboticMowerSetting;
  missionId: number | null;
}

export const initialState: Fields = {
  errorCommands: [],
};

export interface Fields {
  errorCommands: ErrorCommand[];
}

export type ResetErrorParameters = {
  errorId?: number;
  assetId?: AssetId;
  commandName?: RoboticMowerCommand | RoboticMowerSetting;
};

const reducer = createSlice({
  name: 'robotic-mower-command-errors',
  initialState,
  reducers: {
    addErrorCommand: (
      state,
      action: PayloadAction<{
        errorId?: number;
        assetId: AssetId;
        commandName: RoboticMowerCommand | RoboticMowerSetting;
        missionId: number | null;
      }>
    ) => {
      const { errorId, missionId, assetId, commandName } = action.payload;
      state.errorCommands = state.errorCommands.filter((errorCommand) => {
        return !(
          errorCommand.assetId === assetId &&
          errorCommand.commandName === commandName
        );
      });

      state.errorCommands.push({
        errorId: errorId || Math.random() * 100000,
        assetId,
        commandName,
        missionId,
      });
    },
    resetErrorCommand: (state, action: PayloadAction<ResetErrorParameters>) => {
      const { errorId, assetId, commandName } = action.payload;
      state.errorCommands = state.errorCommands.filter(
        (errorCommand) =>
          !(
            errorCommand.errorId === errorId ||
            (errorCommand.assetId === assetId &&
              (!commandName || errorCommand.commandName === commandName))
          )
      );
    },
  },
});

export const { addErrorCommand, resetErrorCommand } = reducer.actions;
export default reducer.reducer;
